import React from "react"

import "./HeatmapComponent.css"
import CalendarHeatmap from "react-calendar-heatmap"
import ReactTooltip from "react-tooltip"
import PopUpComponent from "./PopUpComponent"

import { db } from "../../../firebase/firebase_config.js"
import { collection, getDocs } from "firebase/firestore"
import { dialogTitleClasses } from "@mui/material"

const weekLabelsSpa = ["D", "L", "M", "X", "J", "V", "S"]
const monthsLabelsSpa = [
	"Ene",
	"Feb",
	"Mar",
	"Abr",
	"May",
	"Jun",
	"Jul",
	"Ago",
	"Sept",
	"Oct",
	"Nov",
	"Dic",
]
//auxiliary functions
function shiftDate(date, numDays) {
	const newDate = new Date(date)
	newDate.setDate(newDate.getDate() + numDays)
	return newDate
}

class HeatmapComponent extends React.Component {
	state = {
		loading: true,
		trainings: {},
		showPopup: false,
		selectedData: null,
		showToolTip: true,
	}
	togglePopup() {
		this.setState({
			showPopup: !this.state.showPopup,
		})
	}
	hideToolTip() {
		this.setState({ showToolTip: false })
	}
	showToolTip_Handler() {
		this.setState({ showToolTip: true })
		setTimeout(() => {
			this.setState({ showToolTip: false })
		}, 5000)
	}

	dayClick_handler(value) {
		// console.log(value)
		// console.log(this.state.trainings)

		//Identify data from the selected date
		const data = this.state.trainings.find(function (t) {
			const work_date = new Date(
				t.DATE.seconds * 1000 + t.DATE.nanoseconds / 1000000
			).toString()
			if (work_date === value.date.toString()) return t
			return null
		})
		if (data) {
			this.setState({ selectedData: data })
			//activate popup
			this.togglePopup()
		} else {
			alert(`No se han encontrado entrenos para este el día ${value.date}`)
		}
	}

	async componentDidMount() {
		const trainings_ret = await this.getTrainingData()
		this.setState({
			loading: false,
			trainings: trainings_ret,
		})
		ReactTooltip.rebuild()
	}

	getTrainingData = async () => {
		let trainingsList = []
		try {
			const trainingsCollection = collection(db, "Trainings_V2") //Trainings db testing
			await getDocs(trainingsCollection).then((snapshot) => {
				snapshot.forEach((doc) => {
					trainingsList.push({ ...doc.data(), id: doc.id })
				})
			})
		} catch (error) {
			console.log("Error fetching firestore data: " + error.message)
		}
		//console.log(trainingsList)
		return trainingsList
	}

	getTooltipDataAttrs = (value) => {
		if (value.date && value.count) {
			return {
				"data-tip": `${value.date.toLocaleDateString("es-ES")} hay ${
					value.count
				} ejercicios`,
			}
		} else {
			return {
				"data-tip": "No hay ejercicios",
			}
		}
	}

	render() {
		let datesValues = []
		if (!this.state.loading) {
			datesValues = this.state.trainings.map((t, index) => {
				const work_date = new Date(
					t.DATE.seconds * 1000 + t.DATE.nanoseconds / 1000000
				)
				//const exer_info = Object.entries(t.WOD.EXERCISES)
				let num_exercises = 0
				if (t.WOD) num_exercises += Object.keys(t.WOD).length
				if (t.PARTIDO) num_exercises += Object.keys(t.PARTIDO).length
				if (t.NATACION) num_exercises += Object.keys(t.NATACION).length
				if (t.ALETAS) num_exercises += Object.keys(t.ALETAS).length
				return {
					date: work_date,
					count: num_exercises,
				}
			})
		}
		const today = new Date()
		const start_day = shiftDate(today, -30)
		const end_day = shiftDate(today, +330)

		// const randomValues = getRange(30).map((index) => {
		// 	return {
		// 		date: shiftDate(today, index),
		// 		count: 1,
		// 	}
		// })

		return (
			<div className="react-calendar-heatmap-container">
				<br></br>

				<CalendarHeatmap
					//onMouseLeave={this.hideToolTip.bind(this)}
					onMouseOver={this.showToolTip_Handler.bind(this)}
					startDate={start_day}
					endDate={end_day}
					values={datesValues}
					classForValue={(value) => {
						if (!value) {
							return "color-empty"
						}
						return `color-gitlab-${value.count}`
					}}
					tooltipDataAttrs={this.getTooltipDataAttrs}
					showWeekdayLabels={true}
					weekdayLabels={weekLabelsSpa}
					monthLabels={monthsLabelsSpa}
					onClick={(event) => this.dayClick_handler(event)}
					transformDayElement={(element, value, index) => (
						<g>
							{element}

							<text
								x={element["props"].x}
								y={element["props"].y + 10}
								style={{
									fontSize: "0.35em",
									fill: "#fff",
								}}
							>
								{value ? value.date.getDate() : ""}
							</text>
						</g>
					)}
				/>
				{this.state.showToolTip ? <ReactTooltip /> : null}
				{this.state.showPopup ? (
					<PopUpComponent
						visible={this.state.showPopup}
						data={this.state.selectedData}
					/>
				) : null}
			</div>
		)
	}
}

export default HeatmapComponent
